import { joinURL } from '../../../utilities';
import { standAlonePathName } from '../../area-pathnames';
import { adminAreaPathName, citizenDeletionTabPathName } from '../admin-area-pathnames';

export const citizenDeletionOrdersPathName = 'orders';
export const citizenDeletionOrdersCreatePathName = 'create';
export const citizenDeletionSinglePathName = 'citizen';
export const citizenDeletionTermsPathName = 'terms';

export function citizenDeletionTermsUrl() {
  return joinURL('/', standAlonePathName, adminAreaPathName, citizenDeletionTabPathName, citizenDeletionTermsPathName);
}
